import React from 'react'
import './ProgressBarChart.scss'

function ProgressBarChart({ progress, label }) {
    return (
        <div className="progress-bar-container">
            <div
                className="progress-bar-fill"
                style={{ width: `${progress}%` }}
            ></div>
        </div>
    );

}

export default ProgressBarChart